import { CSSProperties, ImgHTMLAttributes } from 'react';
import styled from 'styled-components';

export const controlStyle: CSSProperties = {
  minWidth: '450px',
  padding: '2px 10px 2px 55px',
  fontSize: 25,
};

export const searchIconStyle: CSSProperties = {
  top: -5,
  fontSize: 21,
  margin: '0px 21px',
};

export const Wrapper = styled.div`
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.backgrounds.tab};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.neutral.lightest}`};
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PartName = styled.div`
  font-size: 30px;
  font-weight: 500;
`;

export const Description = styled.div`
  margin-top: 5px;
`;

export const Info = styled.div`
  font-size: 13px;
  margin-top: 5px;
`;

export const InputWrapper = styled.div`
  width: fit-content;
  min-width: 360px;
  font-size: 25px;
`;

type ImageProps = ImgHTMLAttributes<HTMLImageElement>;

export const Image = styled.img<ImageProps>`
  margin-left: 8px;

  :hover {
    cursor: pointer;
  }
`;
